// Components
import { Entity, EmptyState, Layout } from '@tracklib/kit'
import PlayButton from 'components/playbutton'

// Types
import { Artist, ApiRequest } from 'types'

// Utils
import { isBrowser } from '@process'

import styles from './artistslist.css'

type ArtistsListProps = {
  artists: Array<Artist>
  fetchArtistsRequest: ApiRequest
}
const ArtistsList = ({ artists, fetchArtistsRequest }: ArtistsListProps): JSX.Element => {
  return (
    <Layout.FullWidth>
      {fetchArtistsRequest.isDone && artists.length === 0 && <EmptyState text="No matching artists found" emoji="looking" />}
      <dl>
        <dd className={styles.grid}>
          {artists.length > 0 &&
            artists.map(({ slug, id, name, image }) => (
              <Entity
                url={`/artist/${slug}`}
                key={id}
                title={name}
                image={image?.uri}
                size={5}
                datatesting="entity_artist"
                hoverComponent={<PlayButton entity="artist" value={slug} hoverOnly />}
              />
            ))}
          {(fetchArtistsRequest.isLoading || !isBrowser) &&
            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(index => (
              <Entity loading key={String(index)} datatesting="entity_loading" />
            ))}
        </dd>
      </dl>
    </Layout.FullWidth>
  )
}

export default ArtistsList
